import { defineMessages } from 'react-intl';
export default defineMessages({
    currentObservations: {
        id: 'dashboard.currentObservations',
        defaultMessage: 'Current observations'
    },
    currentRainEvent: {
        id: 'dashboard.currentRainEvent',
        defaultMessage: 'Current rain event'
    },
    currentWeatherConditions: {
        id: 'dashboard.currentWeatherConditions',
        defaultMessage: 'Current conditions'
    },
    customizeDashboard: {
        id: 'dashboard.customizeDashboard',
        defaultMessage: 'Customize'
    },
    customizeDashboardDescription: {
        id: 'dashboard.customizeDashboardDescription',
        defaultMessage: 'Drag items to reorder your dashboard. Tap the eye icon to show or hide sections.'
    },
    dashboard: {
        id: 'dashboard.dashboard',
        defaultMessage: 'Dashboard'
    },
    dayRangeExpected: {
        id: 'dashboard.dayRangeExpected',
        defaultMessage: '{value} expected {time}'
    },
    dayRangeReached: {
        id: 'dashboard.dayRangeReached',
        defaultMessage: '{value} at {time}'
    },
    dayRangeSteady: {
        id: 'dashboard.dayRangeSteady',
        defaultMessage: 'Steady {value} all day'
    },
    hiddenSensors: {
        id: 'dashboard.hiddenSensors',
        defaultMessage: 'Hidden sensors'
    },
    lastRainEvent: {
        id: 'dashboard.lastRainEvent',
        defaultMessage: 'Last rain event'
    },
    manageSensors: {
        id: 'dashboard.manageSensors',
        defaultMessage: 'Manage sensors'
    },
    manageSensorsDescription: {
        id: 'dashboard.manageSensorsDescription',
        defaultMessage: 'Drag items to reorder sensors. Tap the eye icon to show or hide sensors. Tap a name to rename it.'
    },
    pressureSummary: {
        id: 'dashboard.pressureSummary',
        defaultMessage: 'Pressure summary'
    },
    rainEvents: {
        id: 'dashboard.rainEvents',
        defaultMessage: 'Rain events'
    },
    rainSummary: {
        id: 'dashboard.rainSummary',
        defaultMessage: 'Rain summary'
    },
    shareOutdoorMeasures: {
        id: 'dashboard.shareOutdoorMeasures',
        defaultMessage: 'Share your outdoor measures'
    },
    shareOutdoorMeasuresDescription: {
        id: 'dashboard.shareOutdoorMeasuresDescription',
        defaultMessage: 'Participate in the SmartMixin community by making your outdoor measures visible to others. Indoor measures will never be shared.'
    },
    temperatureSummary: {
        id: 'dashboard.temperatureSummary',
        defaultMessage: 'Temperature summary'
    },
    windSummary: {
        id: 'dashboard.windSummary',
        defaultMessage: 'Wind summary'
    }
});
